export default function FinalCTA() {
  return (
    <section id="audit" className="relative overflow-hidden py-28 lg:py-36">
      {/* Full-bleed background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7ad6dd8ac3bdc804e7d1f6489a6fcc04.jpg"
          alt="CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1C2D]/85 via-[#0B1C2D]/75 to-[#0B1C2D]/90" />
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#2563EB]">
            Get Started
          </p>

          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight tracking-tight">
            Precision Automation. Autopilot your Operations
          </h2>

          <p className="text-lg lg:text-xl text-gray-300/90 max-w-2xl mx-auto font-light">
            Install the system that captures every opportunity.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
            <a href="#audit" className="px-10 py-4 bg-white text-[#0B1C2D] font-semibold text-base rounded-full hover:bg-gray-100 transition-all duration-300 shadow-xl whitespace-nowrap cursor-pointer">
              Book Your Systems Audit
            </a>
            <a href="#" className="px-10 py-4 bg-white/10 backdrop-blur-md border border-white/20 text-white font-semibold text-base rounded-full hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Download Overview
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="container mx-auto px-6 lg:px-12 relative z-10 mt-24">
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} AI Desk Pilots. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 transition-colors cursor-pointer" rel="nofollow">Privacy</a>
            <a href="#" className="text-sm text-gray-500 hover:text-gray-300 transition-colors cursor-pointer" rel="nofollow">Terms</a>
          </div>
        </div>
      </div>
    </section>
  );
}
